// extracted by mini-css-extract-plugin
export default {"row":"quickLinkCard_row__7a1sv"};